import { render, staticRenderFns } from "./ModalSelectVehicleModel.vue?vue&type=template&id=0b2332be"
import script from "./ModalSelectVehicleModel.vue?vue&type=script&lang=js"
export * from "./ModalSelectVehicleModel.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectVehicleModel.vue?vue&type=style&index=0&id=0b2332be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports